import type { UiVariant } from "@/ui/view-props";

function parseVariant(v: unknown): UiVariant | null {
  if (v === "classic" || v === "modern" || v === "neon") return v;
  return null;
}

export const UI_VARIANT: UiVariant =
  parseVariant(import.meta.env.VITE_UI_VARIANT) ?? "classic";

